import Swal from 'sweetalert2/dist/sweetalert2.js';

const toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

const swalMessages = {
  methods: {
    $showSuccessMessage(text = `Successfully submitted!`, title = `Success!`) {
      this.$swal.fire({
        icon: 'success',
        title,
        text,
      });
    },
    $showErrorMessage(text = `Something went wrong!`, title = `Error!`) {
      this.$swal.fire({
        icon: 'error',
        title,
        text,
      });
    },
    $showValidationErrorMessage(errors, title = `Information is required!`) {
      this.$swal.fire({
        icon: 'error',
        title,
        text: errors.join(', '),
      });
    },
    $showLoadingMessage() {
      this.$swal.fire({
        icon: 'info',
        title: 'Please Wait!',
        html: 'Your information is being uploaded',
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
    },
    $showConfirmMessage(text = 'Are you sure you would like to delete this item? This action can not be undone.', confirmButtonText = 'Yes, delete it!') {
      return new Promise((resolve, reject) => {
        this.$swal.fire({
          icon: 'warning',
          title: 'Are you sure?',
          text,
          confirmButtonText,
          showCancelButton: true,
          confirmButtonColor: '#007bff',
          cancelButtonColor: '#d33',
        }).then((result) => {
          if (result.isConfirmed) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },

    $showToastSuccessMessage(text = `Successfully submitted!`, timer = 3000) {
      toast.fire({
        icon: 'success',
        title: text,
        timer,
      });
    },
    $showToastErrorMessage(text = `Something went wrong!`, timer = 3000) {
      toast.fire({
        icon: 'error',
        title: text,
        timer,
      });
    }
  }
};

export default swalMessages;
